/**
 * @desc Prompts the user and then applies the license
 */
;(function () {
  'use strict'

  angular
    .module('contrast.servers')
    .factory('serverConfirmAndApplyProtectLicenseService', [
      '$uibModal',
      serverConfirmAndApplyProtectLicenseService
    ])

  function serverConfirmAndApplyProtectLicenseService($uibModal) {
    var service = {
      applyLicense: applyLicense
    }

    return service

    function applyLicense(servers, updateProtection) {
      if (!angular.isArray(servers)) {
        servers = [servers]
      }
      return $uibModal.open({
        templateUrl: 'views/servers/modal_apply_protection_license.html',
        controller: 'ModalApplyProtectionLicenseInstanceCtrl',
        size: 'md-sm',
        backdrop: 'static',
        resolve: {
          servers: function () {
            return servers
          },
          updateProtection: function () {
            return updateProtection
          }
        }
      }).result
    }
  }
})()
